/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  duration: 5500 // Set animation duration as per your animation
};

// Summary And Greeting Section

const greeting = {
  username: "Sarthak Kumar Shailendra",
  title: "Sarthak Kumar Shailendra",
  subTitle: emoji(
    "A passionate Software Engineer 👨🏻‍💻 having an experience of building scalable Backend Systems and Web applications with Springboot / Reactjs / Next.js / Django Rest Framework and various other cutting-edge libraries and frameworks."),
  resumeLink:
    "https://drive.google.com/file/d/1OuplvJc49KZ9NW3RwXCZ33VzfuFLkTmm/view", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/sarthak-kumar-shailendra",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/sarthak-kumar-shailendra/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:sarthak.shailendra@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Dev",
    link: "https://dev.to/sarthakkumarshailendra",
    fontAwesomeIcon: "fa-dev", // Reference https://fontawesome.com/icons/dev?f=brands&s=solid
    backgroundColor: "#090909", // Reference https://simpleicons.org/?q=gmail
  },
];


// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "A DEDICATED FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive and optimized Front end / User Interfaces for your web applications with SEO best practices."
    ),
    emoji("⚡ Develop fast and reliable Backend Systems for your web and mobile applications"),
    emoji(
      "⚡ Integration of third party services such as AWS, Clevertap, Datadog"
    )
  ],

  softwareSkills: [
    {
      skillName: "Springboot",
      fontAwesomeClassname: "simple-icons:springboot",
      style: {
        backgroundColor: "white",
        color: "#6db33f",
      },
    },
    {
      skillName: "ReactJS",
      fontAwesomeClassname: "vscode-icons:file-type-reactjs",
      style: {
        backgroundColor: "transparent",
      },
    },
    {
      skillName: "Next.js",
      fontAwesomeClassname: "logos:nextjs-icon",
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "devicon:java",
      style: {
        backgroundColor: "transparent",
      },
    },
    {
      skillName: "C++",
      fontAwesomeClassname: "logos:c-plusplus",
      style: {
        backgroundColor: "transparent",
      },
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "ion-logo-python",
      style: {
        backgroundColor: "transparent",
        color: "#3776AB",
      },
    },
    {
      skillName: "Django",
      fontAwesomeClassname: "logos:django-icon",
    },
    {
      skillName: "Django Rest Framework",
      fontAwesomeClassname: "devicon:djangorest",
      style: {
        backgroundColor: "transparent",
      },
    },
    {
      skillName: "Postgresql",
      fontAwesomeClassname: "devicon:postgresql",
    },
    {
      skillName: "MS SQL Server",
      fontAwesomeClassname: "devicon-plain:microsoftsqlserver-wordmark",
    },
     {
      skillName: "Tiger Data (prev TimescaleDB)",
      imageSrc: "tiger-data.webp",
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "devicon:mongodb",
      style: {
        backgroundColor: "transparent", 
      },
    },
    {
      skillName: "ASP.NET",
      fontAwesomeClassname: "devicon:dot-net",
      style: {
        backgroundColor: "transparent", 
      },
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "devicon:nodejs-wordmark",
      style: {
        backgroundColor: "transparent",
      },
    },
    {
      skillName: "Redis",
      fontAwesomeClassname: "devicon:redis-wordmark",
    },
    {
      skillName: "Celery",
      imageSrc: "celery.jpeg",
    },
    {
      skillName: "Redux",
      fontAwesomeClassname: "logos:redux",
      style: {
        backgroundColor: "transparent", 
      },
    },
    {
      skillName: "HTML",
      fontAwesomeClassname: "vscode-icons:file-type-html",
      style: {
        backgroundColor: "transparent", 
      },
    },
    {
      skillName: "CSS",
      fontAwesomeClassname: "vscode-icons:file-type-css",
      style: {
        backgroundColor: "transparent", 
      },
    },
    {
      skillName: "Javascript",
      fontAwesomeClassname: "logos:javascript",
      style: {
        backgroundColor: "transparent",
      },
    },
    {
      skillName: "Typescript",
      fontAwesomeClassname: "logos:typescript-icon",
      style: {
        backgroundColor: "transparent", 
      },
    },
    {
      skillName: "Tailwind CSS",
      fontAwesomeClassname: "devicon:tailwindcss",
      style: {
        backgroundColor: "transparent", 
      },
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "devicon:git",
      style: {
        backgroundColor: "transparent", 
      },
    },
    {
      skillName: "AWS S3",
      fontAwesomeClassname: "logos:aws-s3",
      style: {
        backgroundColor: "transparent", 
      },
    },
    {
      skillName: "Jenkins",
      fontAwesomeClassname: "logos:jenkins",
      style: {
        backgroundColor: "transparent", 
      },
    },
    {
      skillName: "Datadog",
      fontAwesomeClassname: "logos:datadog",
      style: {
        backgroundColor: "transparent", 
      },
    },
    {
      skillName: "Clevertap",
      imageSrc: "clevertap.png",
     
    },
    {
      skillName: "Sentry",
      fontAwesomeClassname: "skill-icons:sentry",
    },
    {
    skillName: "Google Lighthouse",
      fontAwesomeClassname: "logos:lighthouse",
    },
    {
      skillName: "Google Search Console",
      imageSrc: "google_search_console.jpeg",
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "simple-icons:docker",
      style: {
        color: '#1D63ED',
      },
    },
    {
      skillName: "Kubernetes",
      fontAwesomeClassname: "logos:kubernetes",
    },
    {
      skillName: "Dagster",
      imageSrc: "dagster.avif",
    },
    {
      skillName: "SEO",
      fontAwesomeClassname: "icon-park:seo",
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Vellore Institute of Technology, Vellore",
      logo: require("./assets/images/vitvellore.jpeg"),
      subHeader: "Bachelor of Technology in Computer Science with specialization in Bioinformatics",
      duration: "July 2017 - June 2021",
      url: "https://vit.ac.in/",
    },
    {
      schoolName: "Bhavan's Bhagwandas Purohit Vidya Mandir, Civil Lines, Nagpur",
      logo: require("./assets/images/bhavans.png"),
      subHeader: "All India Senior School Certificate Examination (Class XII) (PCM)",
      duration: "June 2015 - May 2017",
      url: "http://www.bvmcl.edu.in/",
    },
    {
      schoolName: "Sandipani School",
      logo: require("./assets/images/sandipani.webp"),
      subHeader: "All India Secondary School Examination (Class X)",
      duration: "July 2011 - May 2015",
      url: "http://sandipanischool.edu.in/",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend Development", //Insert stack or technology you have experience in
      progressPercentage: "92%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend Development",
      progressPercentage: "91%"
    },
    {
      Stack: "Programming",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperience = {
  display: true, //Set it to true to show workExperience Section
  experience: [
    {
      role: "Full-stack Developer",
      company: "Mechademy",
      companylogo: require("./assets/images/mechademy.jpeg"),
      url: "https://www.mechademy.com/",
      date: "Aug 2024 – Present",
      descBullets: [
        `My role involves developing full-stack solutions using Next.js & Django, contributing to building advanced analytics &
        diagnostics services for the Oil & Gas industry. I contribute to Turbomechanica, Mechademy's big data platform for
        industrial machinery & focus on integrating advanced ML & proprietary physics-based models to provide deep insights
        into turbomachinery health & deliver predictive, prescriptive alerts that help maximize equipment life & uptime.`
      ]
    },
    {
      role: "Senior Software Engineer - II",
      company: "QuilinX",
      companylogo: require("./assets/images/QuilinX.jpeg"),
      url: "https://quilinx.co",
      date: "Nov 2023 – Jun 2024",
      descBullets: [
        `As a senior developer of the Performance & SEO/Marketing team, I specialized in optimizing Apollo 24|7 & Apollo
        Pharmacy web applications. My role involved implementing strategic optimizations within the Next.js framework,
        focusing on reducing bundle size, developing a custom UI library, optimizing server & client side rendering, implementing Google Search Console insights,
        boosting the lighthouse score & ensuring the application of SEO best practices for enhanced visibility & user experience.`
      ]
    },
    {
      role: "Software Engineer",
      company: "PharmEasy",
      companylogo: require("./assets/images/pharmeasy.png"),
      url: "https://pharmeasy.in/",
      date: "July 2021 – July 2023",
      descBullets: [
        `Developed an end-to-end Java microservice using Springboot, taking complete ownership of every flow, including HLD,
        LLD, DB gateway connections, APIs, PDF generation, AWS S3 bucket storage & retrieval with presigned link functionality & managed
        middleware API calls which eliminated a redundant ticket (30%-40% weekly) that previously required manual queries on multiple tables, saving on-call SDEs an average of 10 minutes per ticket.`,
        `Revamped Rx template (top 5 requested feature by doctors) & developed an API using Django REST framework for
        fetching doctors’ templates from MongoDB, including search, sort & pagination support (missing in the existing API),
        reducing Rx generation time by 31% & improving WEB EMR’s lighthouse score, with fast fetching & search(<300 ms).`,
        "Developed multiple UI features in ReactJS using VSCode to meet business requirements, including a milestone migration from AngularJS to ReactJS that significantly improved the performance & Lighthouse score of Docon PatientMWEB.",
        `Implemented CI CD Azure pipelines for multiple repositories & provided guidance for smooth process transition,
        resulting in a 40% reduction in deployment time, lower error rates & increased developer productivity by streamlining
        the previously manual deployment process of publishing, zipping & sharing files with the admin.`,
        "Demonstrated customer prioritization by resolving CST tickets promptly & achieving a notable 0 ticket count.",
        "Got exposed to various frontend/backend frameworks and libraries like Angular, React, Django Rest Framework, Springboot, ASP.Net, AWS (S3), MS SQL SERVER, MongoDB, Redis, Nodejs."
      ]
    },
    {
      role: "Summer Intern",
      company: "Yamaha Motor Solutions India Pvt.Ltd",
      companylogo: require("./assets/images/yamaha.jpeg"),
      url: "https://www.ymsl.in/",
      date: "July 2020 – September 2020",
      descBullets: [
        "Developed a C++ program, which reads Light Detection and Ranging (LiDAR) data (or Point Cloud data) of forest canopies in LAS format, generating a smoothed digital surface model (DSM) which helps enable an autonomous drone to effectively navigate & follow the smoothed terrain for more efficient crop fertilization.",
        `Transformed Point Cloud data to x,y,z coordinates and found the tree tops and the boundary of the forest using open source libraries like Point Cloud Library (PCL), PDAL & CGAL.`,
        `Applied Delaunay Triangulation, deflection & satisfied maximum slope angle to create the "Fake Smoothed Canopy Model Generator".`,
        "Applied FLANN library for performing fast approximate nearest neighbor searches, thereby reducing processing times for large point cloud datasets in Visual Studio."
      ]
    }
  ]
};

// Some big projects you have worked on

const bigProjects = {
  title: "Technical Contributions",
  subtitle: "I've contributed to developing tech for various startups and companies.",
  projects: [
    {
      image: require("./assets/images/apollo247.png"),
      projectName: "Apollo 24|7",
      projectDesc: "Apollo 24|7 is the largest multi-channel digital healthcare platform in India, created with a vision of eliminating flexibility blockages from the healthcare industry, where you have access to a wide range of services such as online pharmacy, online doctor consultations, and diagnostic lab tests at home.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.apollo247.com"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/apollopharmacy.jpeg"),
      projectName: "Apollo Pharmacy",
      projectDesc: "Apollo Pharmacy is a subsidiary of Apollo Hospitals & is the largest & first-ever Omni-Channel Pharmacy network in Asia. Apollopharmacy.in is a one-stop online destination with a vast range of over 70,000 products in various categories such as vitamins & supplements, personal care, health, nutritional foods, and OTC.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.apollopharmacy.in"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/thyronxt.png"),
      projectName: "ThyroNXT by Thyrocare",
      projectDesc: "ThyroNXT is the storefront partner app used by Thyrocare partners (franchises) to punch in diagnostic orders, download reports, manage customer lifecycle, identify details of various diagnostic tests, and much more.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://thyronxt.thyrocare.com"
        }
      ]
    },
    {
      image: require("./assets/images/docon_emr.png"),
      projectName: "Docon Technologies Pvt Ltd",
      projectDesc: "Docon is India’s first EMR Platform that enables a doctor to not only digitise his/her practice but enable better patient care via our virtual clinic services. It's a one-stop solution for all Doctor needs.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://docon.co.in/emr/login"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/docon_patient.webp"),
      projectName: "Docon for Patients",
      projectDesc: "Docon for patients provides best-in-class platform for patients to connect with their doctors safely. Patients can book in-clinic or video consultation appointments and access the E-prescriptions sent by the doctor.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://docon.co.in/patientmweb"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

// const achievementSection = {
//   title: emoji("Achievements And Certifications 🏆 "),
//   subtitle:
//     "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

//   achievementsCards: [
//     {
//       title: "Rising Star",
//       subtitle:
//         "Recognized as a ”Rising Star” by PharmEasy for exceptional performance in two consecutive quarters.",
//       image: require("./assets/images/api_holdings.jpeg"),
//       imageAlt: "Rising Star - API Holdings",
//       footerLink: [
//         {
//           name: "Certification",
//           url: "https://drive.google.com/file/d/1kpQRXHUDNriTWp6Kl1c4sYcTTg8IvpPH/view"
//         },
//       ]
//     },
//     {
//       title: "Academic Content Creator",
//       subtitle:
//         "Interned at Abyeti Technologies as an Academic Content Creator.",
//       image: require("./assets/images/abyeti.png"),
//       imageAlt: "Abyeti Technologies",
//       footerLink: [
//         {
//           name: "Certification",
//           url: "https://drive.google.com/file/d/1B_p1rgeMrsNkJtr75bP0GorUZnuNswZk/view?usp=sharing"
//         }
//       ]
//     },
//   ],
//   display: false// Set false to hide this section, defaults to true
// };

const certifications = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, certifications, and a collection of impressive courses I've undertaken!",

  certifications: [
    {
      title: "Hacktoberfest 2025: Hall of Fame",
      subtitle: "Hacktoberfest 12",
      logo_path: "hacktoberfest2025.png",
      certificate_link:
        "https://www.holopin.io/hacktoberfest2025/userbadge/cmh4ydt4e001dld04tlnq3r8p",
      alt_name: "Hacktoberfest 12",
      color_code: "#1C1C3F",
    },
    {
      title: "Hacktoberfest 2024: Hall of Fame",
      subtitle: "Hacktoberfest 11",
      logo_path: "hacktoberfest11.png",
      certificate_link:
        "https://www.holopin.io/hacktoberfest2024/userbadge/cm2p1p61h60830cjv5hoense6",
      alt_name: "Hacktoberfest 11",
      color_code: "#183717",
    },
    {
      title: "Hacktoberfest 2023: Hall of Fame",
      subtitle: "Hacktoberfest 10",
      logo_path: "hacktoberfest.jpeg",
      certificate_link:
        "https://www.holopin.io/hacktoberfest2023/hall/@sarthakkshailendra",
      alt_name: "Hacktoberfest 10",
      color_code: "#000",
    },
    {
      title: "Rising Star",
      subtitle: "API Holdings",
      logo_path: "api_holdings.jpeg",
      certificate_link:
        "https://drive.google.com/file/d/1kpQRXHUDNriTWp6Kl1c4sYcTTg8IvpPH/view",
      alt_name: "API Holdings",
      color_code: "#149f98",
    },
    {
      title: "Academic Content Creator",
      subtitle: "Abyeti Technologies Pvt Ltd",
      logo_path: "abyeti.png",
      certificate_link:
        "https://drive.google.com/file/d/1B_p1rgeMrsNkJtr75bP0GorUZnuNswZk/view?usp=sharing",
      alt_name: "Abyeti Technologies Pvt Ltd",
      color_code: "white",
    },
    {
      title: "Machine Learning",
      subtitle: "Stanford University",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/AAV3RVEGF4V9",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Secure Software Design",
      subtitle: "University of Colorado",
      logo_path: "colorado.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/P8E5KS27QW6M",
      alt_name: "University of Colorado",
      color_code: 'white',
    },
    {
      title: "HTML, CSS, and Javascript for Web Developers",
      subtitle: "John Hopkins University",
      logo_path: "John-Hopkins-University.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/SD9TKPDRYK4L",
      alt_name: "John Hopkins University",
      color_code: "#1E376D",
    },
    {
      title: "Text Retrieval and Search Engines",
      subtitle: "University of Illinois at Urbana-Champaign",
      logo_path: "illinois.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/APLTGTK4TRUY",
      alt_name: "University of Illinois at Urbana-Champaign",
      color_code: "#13294B",
    },
    {
      title: "Automata Theory",
      subtitle: "Stanford University",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1LKOGdGHhXsqxq1k4Y1Oa5gJ9Ue_ecBMg/view?usp=sharing",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Business Analytics for Decision Making",
      subtitle: "University of Colorado",
      logo_path: "colorado.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/UP2AD3YUQH4R",
      alt_name: "University of Colorado",
      color_code: 'white',
    },
    // {
    //   title: "Introduction to Genetics and Evolution",
    //   subtitle: "Duke University",
    //   logo_path: "duke_university.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/9MV7Q5M7MB3L",
    //   alt_name: "Duke University",
    //   color_code: '#00539B',
    // },
  ],
  display: true,
};

const linkedInSection = {
  title: emoji("LinkedIn"),
  subtitle: "Key moments from my LinkedIn profile",
  display: true
};

const articleSection = {
  user: "sarthakkumarshailendra",
  title: emoji("Articles"),
  subtitle: "Some of my published blogs and articles",
  display: true
};

const contactInfo = {
  title: emoji("Contact Me 📱"),
  subtitle:
    "HAVE AN OPENING AT YOUR ORGANIZATION ? OR WANT TO DISCUSS ON A FREELANCE PROJECT ? MY INBOX IS OPEN FOR ALL.",
  number: "",
  email_address: "sarthak.shailendra@gmail.com",
  location: "Chandigarh, India",
  map_location: "https://www.google.com/maps/place/Chandigarh/@30.7350554,76.6811271,12z/data=!3m1!4b1!4m6!3m5!1s0x390fed0be66ec96b:0xa5ff67f9527319fe!8m2!3d30.7333148!4d76.7794179!16zL20vMDFmMXE4?entry=ttu",
};

export {
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperience,
  bigProjects,
  contactInfo,
  certifications,
  linkedInSection,
  articleSection,
};
